import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import BranchesIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/branches'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'settings_branches_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'settings_branches_list',
          component: BranchesIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
